export enum BaseShiftTypeEnum {
  FD = 'fd',
  ZD = 'zd',
  SD = 'sd',
  ND = 'nd',
}
